import { object, string } from 'yup';
import HttpStatus from 'http-status-codes';

export const SchemaError = {
  [HttpStatus.BAD_REQUEST]: {
    bedroomsCount: 'Invalid request'
  }
};

export default object().shape({
  property_name: string().required('Please enter property name'),
  city: string().required('Please enter city'),
  state: string().required('Please enter state'),
  name: string().required('Please enter your name'),
  phone: string()
    .matches(/\d{3}-\d{3}-\d{4}$/, 'Please use xxx-xxx-xxxx format')
    .nullable(),
  email: string()
    .email('Please enter a valid email')
    .nullable()
});
